var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeopleIcon = function SvgPeopleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 34c-8.284 0-15-6.715-15-15S10.716 4 19 4c8.285 0 15 6.716 15 15 0 8.285-6.715 15-15 15m0-3c6.627 0 12-5.373 12-12S25.627 7 19 7 7 12.373 7 19s5.373 12 12 12m-4.5-12h-3a7.5 7.5 0 0 0 15 0h-3a4.5 4.5 0 1 1-9 0",
    clipRule: "evenodd"
  })));
};
export default SvgPeopleIcon;